import * as React from 'react';
import * as styles from './OrgAssetBreadCrumb.css';
import { IOrgAssetBreadCrumbPath } from '../../../../interfaces/OrgAssets/IOrgAssetBreadCrumbPath';
import { LocalizationService } from '../../../../services/LocalizationService';


export interface IAOrgAssetBreadCrumbProps {
  isLoading: boolean;
  breadCrumbPath: IOrgAssetBreadCrumbPath[];
  onClickTopLevel: () => void;
  onClickFolder: (breadCrumb: IOrgAssetBreadCrumbPath) => void;
}

export interface IAOrgAssetBreadCrumbState {
}

export class IAOrgAssetBreadCrumb extends React.Component<IAOrgAssetBreadCrumbProps, IAOrgAssetBreadCrumbState> {
  private readonly localizationService = new LocalizationService();
  
  constructor(props: IAOrgAssetBreadCrumbProps) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
    <div className={styles.IA_OrgAssetBreadCrumbContainer}>
      <div
        className={styles.IA_OrgAssetBreadCrumb}
        onClick={() => this.props.onClickTopLevel()}
      >
        {this.localizationService.strings.Uploader_OurOrganization_OrgAsset}
      </div>
      {this.props.breadCrumbPath.map((breadCrumb, i) => {
        const isLast = i + 1 === this.props.breadCrumbPath.length;
        return <div
          className={[styles.IA_OrgAssetBreadCrumb, styles.IA_OrgAssetBreadCrumbChild].join(" ")}
          style={{
            cursor: isLast ? "default" : undefined,
            fontWeight: isLast ? "bold" : undefined,
            pointerEvents: isLast ? "none" : undefined
          }}
          onClick={() => this.props.onClickFolder(breadCrumb)}
        >
          {breadCrumb.name}
        </div>
      })}
    </div>
    );
  }
}
